import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const OrderDetailsForm = ({
  onChange,
  initialName = "",
  initialPhone = "",
  availableTimes,
  onDeliveryMethodChange, // Nueva prop para notificar cambios
}) => {
  const dataUser = useSelector((state) => state.user.dataUser);

  const [delivery, setDelivery] = useState(null);
  const [payMethod, setPayMethod] = useState(null);
  const [contactPhone, setContactPhone] = useState(initialPhone);
  const [orderAddress, setOrderAddress] = useState("");
  const [observations, setObservations] = useState("");
  const [name, setName] = useState(initialName);
  const [endTime, setEndTime] = useState(""); // Estado para la hora seleccionada

  useEffect(() => {
    setContactPhone(initialPhone);
  }, [initialPhone]);

  useEffect(() => {
    setName(initialName);
  }, [initialName]);

  useEffect(() => {
    if (onChange) {
      onChange({
        delivery,
        pay_method: payMethod,
        contact_phone: contactPhone,
        order_address: orderAddress,
        observations,
        name,
        email: dataUser?.email || "",
        end_time: endTime, 
      });
    }
  }, [
    delivery,
    payMethod,
    contactPhone,
    orderAddress,
    observations,
    name,
    endTime, // Añadir al array de dependencias
    onChange,
    dataUser,
  ]);

  // Función para manejar cambio en la forma de entrega
  const handleDeliveryChange = (newDelivery) => {
    setDelivery(newDelivery);
    setEndTime(""); // Limpiar horario seleccionado
    
    // Notificar al componente padre sobre el cambio
    if (onDeliveryMethodChange) {
      onDeliveryMethodChange(newDelivery);
    }
  };

  return (
    <div className="card p-3 my-4">
      <div className="d-flex flex-wrap">
        <div className="mb-2 me-4">
          <strong>Forma de entrega</strong>
          <div>
            <label className="me-3">
              <input
                type="radio"
                name="delivery"
                className="form-check-input rounded-circle"
                checked={delivery === true}
                onChange={() => handleDeliveryChange(true)}
              />{" "}
              Delivery
            </label>
            <label>
              <input
                type="radio"
                name="delivery"
                className="form-check-input rounded-circle"
                checked={delivery === false}
                onChange={() => handleDeliveryChange(false)}
              />{" "}
              Retiro en local
            </label>
          </div>
        </div>
        <div className="mb-2">
          <strong>Forma de pago:</strong>
          <div>
            <label className="me-3">
              <input
                type="radio"
                name="payMethod"
                className="form-check-input rounded-circle"
                checked={payMethod === 1}
                onChange={() => setPayMethod(1)}
              />{" "}
              Efectivo
            </label>
            <label>
              <input
                type="radio"
                name="payMethod"
                className="form-check-input rounded-circle"
                checked={payMethod === 2}
                onChange={() => setPayMethod(2)}
              />{" "}
              Transferencia
            </label>
          </div>
        </div>
      </div>

      <div className="mb-2">
        <label className="form-label fw-bold" htmlFor="end_time">
          Horario de entrega/retiro:
        </label>
        <select
          id="end_time"
          className="form-select"
          value={endTime}
          onChange={(e) => setEndTime(e.target.value)}
          disabled={delivery === null || !availableTimes || availableTimes.length === 0}
        >
          <option value="">
            {delivery === null
              ? "Selecciona primero la forma de entrega"
              : availableTimes && availableTimes.length > 0
              ? "Selecciona un horario"
              : "No hay horarios disponibles"}
          </option>
          {availableTimes &&
            availableTimes.map((time, index) => (
              <option key={index} value={time.end_time}>
                {time.end_time}
              </option>
            ))}
        </select>
      </div>

      <div className="mb-2">
        <label className="form-label fw-bold" htmlFor="name">
          Nombre:
        </label>
        <input
          id="name"
          type="text"
          className="form-control"
          defaultValue={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Tu nombre"
        />
      </div>
      <div className="mb-2">
        <label className="form-label fw-bold" htmlFor="contactPhone">
          Teléfono de contacto:
        </label>
        <input
          id="contactPhone"
          type="tel"
          className="form-control"
          value={contactPhone}
          onChange={(e) => setContactPhone(e.target.value)}
          placeholder="Telefono: "
        />
      </div>
      <div className="mb-2">
        <label className="form-label fw-bold" htmlFor="orderAddress">
          Dirección:
        </label>
        <input
          id="orderAddress"
          type="text"
          className="form-control"
          value={orderAddress}
          onChange={(e) => setOrderAddress(e.target.value)}
          placeholder="Dirección: "
          disabled={!delivery}
        />
      </div>
      <div className="mb-2">
        <label className="form-label fw-bold" htmlFor="observations">
          Observaciones:
        </label>
        <textarea
          id="observations"
          className="form-control"
          value={observations}
          onChange={(e) => setObservations(e.target.value)}
          placeholder="Aclaraciones sobre tu pedido"
        />
      </div>
    </div>
  );
};

export default OrderDetailsForm;